import React, { ReactNode } from 'react';
import classNames from 'classnames';
import makeStyles from 'e100-react-components/lib/styles/makeStyles';
import Grid, { IPropTypes as GridProps } from 'e100-react-components/lib/components/Grid';
import { IPropTypes } from 'e100-react-components/lib/components/Typography';
import { Typography } from 'shared/components';
import Icon, { Props as IconProps } from 'components/Icon';

const useStyles = makeStyles(theme => ({
  subtitle: {
    color: theme.palette.secondary.main
  },
  iconContainer: {
    lineHeight: 0,
    width: theme.spacing(5)
  },
  container: ({ gutterBottom }: { gutterBottom: number }) => ({
    marginBottom: theme.spacing(gutterBottom)
  })
}));

const IconedPanel = ({
  icon,
  subtitle,
  title,
  customIcon = null,
  gutterBottom = 0,
  children = null,
  subtitleVariant = "body2",
  classes = {},
  spacing = 2,
  alignItems
}: Props) => {
  const innerClasses = useStyles({ gutterBottom });
  return (
    <Grid
      container
      alignItems={alignItems || (subtitle ? 'flex-start' : 'center')}
      spacing={spacing}
      wrap="nowrap"
      classes={{
        root: classNames({
          [innerClasses.container]: true,
          [classes.container || '']: true
        })
      }}
    >
      <Grid item xs='auto' classes={{ item: innerClasses.iconContainer }}>
        {icon && <Icon
          color="secondary"
          kind={icon as IconProps['kind']}
          classes={{
            root: classNames({
              [innerClasses.subtitle]: true,
              [classes.icon || '']: true
            })
          }}
        />}
        {!!customIcon && customIcon}
      </Grid>
      <Grid item xs={12}>
        {title && (
          <Typography variant="body2">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            variant={subtitleVariant}
            classes={{ root: innerClasses.subtitle }}
          >
            {subtitle}
          </Typography>
        )}
        {children}
      </Grid>
    </Grid>
  );
};

export default IconedPanel;

interface Classes {
  container?: string;
  icon?: string;
}
export interface Props {
  children?: ReactNode;
  icon?: string,
  subtitle?: any,
  title?: ReactNode,
  customIcon?: ReactNode,
  gutterBottom?: number,
  subtitleVariant?: IPropTypes['variant'],
  classes?: Classes;
  spacing?: GridProps['spacing'];
  alignItems?: GridProps['alignItems'];
};